<div class="lheader">
    <div class="lheader-company" (click)="navToIndex()">
		<mat-icon svgIcon="pro" class="lheader-company-logo"></mat-icon>
        <div class="lheader-company-name"> {{ userProfile?.project_setting.project.name }}</div>
	</div>
  <div class="lheader-2block">
    <div class="lheader-2block-search">
      <mat-icon svgIcon="search-line" class="base-icon" style="width: 18px;"></mat-icon>
        <input matInput  [formControl] = "searchControl" placeholder="Поиск" class="lheader-2block-search-input body-m-regular text-extra">
    </div>
    <div class="lheader-2block-icons">
      <div class="lheader-2block-icons-item" (click)="createWidgetInstruct()" *ngIf="showWidgets"   
        [matTooltip]="'WIDGETS.ADD_WIDGET' | translate" >
        <mat-icon svgIcon="add-box-fill" class="lheader-2block-icons-item-icon" style="transform: scale(1);"></mat-icon>
      </div>
      <div class="lheader-2block-icons-item" (click)="toggleWidgetData()" [matTooltip]="'GLOBAL_MENU.WIDGETS' | translate">
        <mat-icon svgIcon="layout-grid-fill" class="lheader-2block-icons-item-icon"></mat-icon>
      </div>
      <div class="lheader-2block-icons-item" (click)="goToBank()" [matTooltip]="'CONTRACTS.CARD.BANK_PRODUCTS' | translate">
        <mat-icon svgIcon="wallet-2-fill" class="lheader-2block-icons-item-icon"></mat-icon>
      </div>
      <div class="lheader-2block-icons-item" (click)="toggleNotifications()" [matTooltip]="'MODALS.HEADERS.NOTIFICATIONS' | translate">
        <mat-icon svgIcon="notification-3-fill" class="lheader-2block-icons-item-icon"></mat-icon>
      </div>
      <div class="lheader-2block-icons-item" (click)="selectCompany()" [matTooltip]="'GLOBAL_MENU.PROJECTS' | translate">
        <mat-icon svgIcon="user-shared-fill" class="lheader-2block-icons-item-icon"></mat-icon>
      </div>
    </div>
    <div class="vertical-divider"></div>
    <div class="lheader-2block-user" (click)="toggleUserProfile()">
      <app-avatar *ngIf="userProfile"  class="lheader-2block-user-avatar"
        [profile]="userProfile"
        [size]="'medium'" 
        (hasAvatar)="detectChanges()"
        >
      </app-avatar>
      <div class="lheader-2block-user-data">
        <div class="lheader-2block-user-data-name">{{userProfile?.full_name}}</div>
          <div class="lheader-2block-user-data-title">{{ userProfile?.project_setting.position }}</div>
      </div>
      <mat-icon svgIcon="arrow-down-s-line" class="lheader-2block-icons-item-icon"></mat-icon>
      <div class="lheader-2block-user-profile" [class.user-profile-hidden]="isUserProfileHidden">
      <app-m-layout-user-profile [class.user-profile-hidden]="isUserProfileHidden"></app-m-layout-user-profile>
      </div>
       
    </div>
  </div>
</div>

